export function formatDate(date: Date | undefined): string | undefined {
  return date ? new Date(date).toISOString() : undefined;
}
